import { useQuery } from '@tanstack/react-query';
import { userClient } from 'clients/UserClient/UserClient';
import { TenantLogo } from 'shared/ui/tenant-logo';
import { QueryKey } from 'types/query';
import { useCurrentUserQuery } from './useCurrentUserQuery';

export const useGetTenantBrandingQuery = () => {
  const { data: currentUser } = useCurrentUserQuery();

  return useQuery(
    [QueryKey.useGetTenantBrandingQuery],
    async () => {
      const { data } = await userClient.getTenantCurrentUser();
      return data;
    },
    {
      enabled: !!currentUser?.tenant.id,
      onSuccess: (data) => {
        TenantLogo.setTenant({
          primaryColor: data?.primary_color ?? undefined,
          logoUrl: data?.logo_url ?? undefined,
        });
      },
    },
  );
};
